import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import * as encoding from 'encoding-japanese';

import { ResultMailService } from '../../../service/result-mail/result-mail.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { isAuthority } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9150.component.html',
  styleUrls: ['wa9150.component.scss']
})
export class Wa9150Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9150:実績メールマスタ照会';

  public owners: any;

  public ownerId: number;

  public config = config;

  public gridOptions: GridOptions;
  public showGrid = false;
  public rowData: any[];

  private isEnableClearFilter = false;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public sessionOwnerKey = 'wa9150-owner';

  // Authorith
  public disableF3 = isAuthority('wa9150', 'F3');
  public ownerResult;
  public errorMssage;
  private gridHelper: AgGridHelper;
  private selectedCount = 0;

  private errorInfo = '';
  private isShow9151 = false;

  @ViewChild('gridView')
  gridView: ElementRef;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;

  private isOwnerSearchNone = false;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  constructor(
    private router: Router,
    private resultMailService: ResultMailService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    // grid
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -121;
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    environment.gridLocale.noRowsToShow = '<p class="nodata">荷主を選択してください</p>';
    this.gridOptions = <GridOptions>{
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      rowSelection: 'single',
      suppressRowClickSelection: false,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onFilterChanged: () => {
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorMssage = '';
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9150_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA
    };
    this.gridOptions.columnDefs = [
      {
        field: 'checkbox',
        headerName: '',
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: true,
        suppressFilter: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        checkboxSelection: true,
        suppressMenu: true,
        //lockPosition: true,
        pinned: 'left'
      },

      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '帳票コード',
        field: 'reportCd',
        sort: 'asc',
        width: this.getColumnWidth('reportCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '帳票名',
        field: 'reportTx',
        width: this.getColumnWidth('reportTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'Fromアドレス',
        field: 'mailfromTx',
        width: this.getColumnWidth('mailfromTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'Toアドレス',
        field: 'mailtoTx',
        width: this.getColumnWidth('mailtoTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'Ccアドレス',
        field: 'mailccTx',
        width: this.getColumnWidth('mailccTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'メールタイトル',
        field: 'mailsubjectTx',
        width: this.getColumnWidth('mailsubjectTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'メール本文',
        field: 'mailbodyTx',
        width: this.getColumnWidth('mailbodyTx', 240),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '添付ファイル名',
        field: 'fileTx',
        width: this.getColumnWidth('fileTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '送信時刻',
        field: 'sendTm',
        width: this.getColumnWidth('fileTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonForthMargin;
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
      this.onSubmit();
    }
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9150_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9150_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9150_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonForthMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // drop down list
    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;

        this.ownerId = undefined;
        let ownerResult = sessionStorage.getItem('ownerResult');
        if (ownerResult !== null) {
          const selectedOwner = JSON.parse(ownerResult);
          this.ownerId = selectedOwner.ownerId;
        }
        this.onSubmit();
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    // this.onFilterClear();
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.resultMailService
      .get(this.ownerId)
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.rowData = outputJson.resultmails;
        this.showGrid = true;
        this.gridHelper.selectedAnimateDelay();
        setTimeout(() => {
          this.working = false;
        },300);
      })
      .catch(error => {
        this.rowData = [];
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.showGrid = false;
        this.working = false;
      });
  }

  upd() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('resultmail', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa9151']);
  }
  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  changeOwner(selectedOwnerId) {
    this.errorMssage = '';
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];

      this.gridOptions.api.deselectAll();
    }
  }
  onShow9151() {
    if (this.selectedCount == 0) return;
    this.rowData[this.gridOptions.api.getSelectedNodes()[0]['id']];
    sessionStorage.setItem('resultmail', JSON.stringify(this.rowData[this.gridOptions.api.getSelectedNodes()[0]['id']]));
    this.isShow9151 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }
  onClose9151(isCloseAndRefreshGrid: boolean) {
    sessionStorage.setItem('isShowOwnerSelect', 'true');
    this.isShow9151 = false;
    if (isCloseAndRefreshGrid) {
      this.gridHelper.prepareSelectedAnimateByNodes(this.gridOptions.api.getSelectedNodes());
      this.onSubmit();
    }
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9150/wa9150.component.ts